import withRegistroTrabajador from "../../hoc/withTrabajadores/withRegistroTrabajador";
import RegistroUsuarios from "../../view/components/RegistroUsuarios/RegistroUsuarios";

export default withRegistroTrabajador(RegistroUsuarios);